import { connectWithStore } from '@common/connectWithStore';

import { getFeatures } from '@react/Pages/AccountSettingsPage/PricingPlanPage/features';
import { isYearly } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { PricingPlanFeatures } from './PricingPlanFeatures';

const mapStateToProps = state => ({
  features: getFeatures(t),
  isYearly: isYearly(state),
});

export const PricingPlanFeaturesContainer = connectWithStore(mapStateToProps)(PricingPlanFeatures);
